<h3 class="font-bold text-lg">Einsätze anpassen</h3>
<div class="flex flex-col gap-2 min-h-48 justify-center items-center">
  @if (isLoading()) {
    <div class="flex items-center justify-center">
      <span class="fa fa-spinner fa-spin text-2xl"></span>
    </div>
  } @else if (!operationIds()?.length) {
    <div class="text-center">Keine Einstätze gefunden</div>
  } @else {
    <button class="bm-btn bm-btn-block bm-btn-error" [disabled]="isSaving()" (click)="handleDeleteClicked()">
      {{ deletableIds().length }} Einsätze löschen
    </button>
    <button class="bm-btn bm-btn-block bm-btn-error" [disabled]="isSaving()" (click)="handleResetClicked()">
      {{ operationIds().length }} Einsätze auf "nicht vergeben"
    </button>
  }
  @if (batchError()) {
    <div class="bm-alert bm-alert-error">
      <span class="fa fa-exclamation-triangle"></span>
      <span>{{ batchError() }}</span>
    </div>
  }
</div>

<div class="flex flex-row items-center justify-end gap-2">
  <button class="bm-btn bm-btn-secondary" (click)="handleCancel()">Abbrechen</button>
</div>
